import { useEffect, useState } from 'react';
import { NavBar } from '../../../../../themes/components/Navbar';
import { Sidebar } from '../../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { FooterRelatorios } from '../../../components/FooterRelatorios';
import { VscRunAll } from 'react-icons/vsc';
import { AiOutlineClear } from 'react-icons/ai';
import { Button } from '../../../../../themes/components/Button';
import { useRelatorios } from '../../../../../contexts/Relatorios';
import ReactLoading from 'react-loading';
import { useHistory } from 'react-router-dom';
import { useModals } from '../../../../../contexts/Modals';
import { ContainerRelatorio } from '../../../components/VisualizarRelatorio';
import { FieldDropdownVer2 } from '../../../../../themes/components/FieldDropdown';
import { ArrayProdutos, Produto } from '../../../../pedidos/interfaces';
import { usePedidos } from '../../../../../contexts/Pedidos';
import { FieldDropdown } from '../../../../../themes/components/FieldDropdown';

export const SECE500 = () => {
    const history = useHistory();
    const { mostrarInfoOK } = useModals();
    const { filtrarProdutos } = usePedidos();
    const { loadingRelatorio, urls, setUrls, gerarRelatorio, setLoadingRelatorio } = useRelatorios();
    const [listaProdutos, setListaProdutos] = useState<ArrayProdutos>();
    const [loadingProdutos, setLoadingProdutos] = useState<boolean>(false);
    const [fieldProduto, setFieldProduto] = useState<string>("");
    const [codAgrup, setCodAgrup] = useState<string>("");

    const [estoque, setEstoque] = useState("GA");
    const [iEstoque, setIEstoque] = useState("2");
    const optEstoque = [
        { "cod": "2", "nome": "GA" },
        { "cod": "4", "nome": "AB" }
    ];
    const [codRelatorio, setCodRelatorio] = useState("");
    useEffect(() => {
        let cod = iEstoque == "2" ? "SECE500" : iEstoque == "4" ? "SECE504" : "SECE500";

        // component unmount 
        return () => {
            setLoadingRelatorio((prevState) => ({
                ...prevState,
                cod: false
            }))
        }
    }, [iEstoque]);

    function handleClearFields() {
        setFieldProduto("");
        setCodAgrup("");
        setEstoque("GA");
        setIEstoque("2");
    }

    function solicitarRelatorio() {
        let cod = iEstoque == "2" ? "SECE500" : iEstoque == "4" ? "SECE504" : "SECE500";
        let objParams: any = [];
        if (fieldProduto != "") {
            if (codAgrup != "") {
                objParams.push({ nome: "CODCLC", valor: codAgrup })
            }
            objParams.push({ nome: "CODEMP", valor: iEstoque })
            setUrls((prevState) => ({
                ...prevState,
                cod: ""
            }))
            gerarRelatorio(cod, JSON.parse(JSON.stringify(objParams)), history);
            setCodRelatorio(cod);
        } else {
            mostrarInfoOK("É necessário selecionar um código de agrupamento para gerar este relatório.");
        }
    }

    function handleChangeProduto(event: any, option: any, reason: any) {
        async function getProduto() {
            await filtrarProdutos(event.target.value, history)
                .then((res) => {
                    setListaProdutos(res);
                    setLoadingProdutos(false);
                })
                .catch((err) => {
                    if (err !== "Cancel") {
                        setListaProdutos([]);
                        console.log(err);
                        setLoadingProdutos(false);
                    }
                })

        }

        if (reason === "input" && event !== null && event.target.value.trim() !== "") {
            if (fieldProduto !== "") {
                setFieldProduto("");
            }
            setLoadingProdutos(true);
            getProduto();
        }

        if (reason === "reset" && option.trim() !== "") {
            let cod = new RegExp("[0-9]*", '').exec(option);
            if (cod !== null) {
                setCodAgrup(cod[0]);
                setFieldProduto(cod[0]);
            }
        }

        if (reason === "clear" || (event !== null && String(event.target.value).trim() === "")) {
            handleClearFields();
        }
    }

    function getOptionByCod(cod: string) {
        for (let index = 0; listaProdutos && index < listaProdutos.length; index++) {
            const element = listaProdutos[index];
            if (element.codclc === cod) {
                return element;
            }
        }
        return "";
    }

    function getEstoqueList() {
        let temp: string[] = []
        optEstoque.forEach((opt) => {
            temp.push(opt.nome)
        })
        return temp;
    }

    function getCodEstoque(text: string) {
        let sit = "";
        optEstoque.forEach((opt) => {
            if (opt.nome === text) {
                sit = opt.cod;
            }
        })
        return sit;
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div className="main-content-relatorios">
                    <NavBar />
                    <span className="novo-pedido-title-form">Parâmetros do Relatório</span>
                    <div className="relatorios-campo-busca">
                        <form>
                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="consulta-combobox-tipo-pedido">Código do Agrupamento</label>
                                    <div className="pedido-linha-campo">
                                        <FieldDropdownVer2
                                            id="additens-combobox-searchproduto"
                                            options={listaProdutos || []}
                                            loading={loadingProdutos}
                                            value={getOptionByCod(fieldProduto)}
                                            select={(option: Produto, value: Produto) => option.codclc === value.codclc}
                                            label={(option: Produto) => option.codclc !== undefined ? option.codclc + " - " + option.nompro : ""}
                                            onChange={(event, option, reason) => handleChangeProduto(event, option, reason)}
                                            noOptionsText={"Digite um código ou nome válido"}
                                        />
                                    </div>
                                </div>
                                <div className="form-group" >
                                    <label htmlFor="consulta-combobox-tipo-pedido">Empresa</label>
                                    <div className={""}>
                                        <FieldDropdown
                                            value={estoque}
                                            id="seleciona-combobox-estoque"
                                            options={getEstoqueList()}
                                            label={(option: string) => option}
                                            onChange={(event, newInputValue) => {
                                                setEstoque(newInputValue);
                                                setIEstoque(getCodEstoque(newInputValue));
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="form-buttons">
                                    <Button titleText="Gerar relatório" classBtn="" onClick={() => solicitarRelatorio()} >
                                        <VscRunAll color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                    <Button titleText="Limpar campos" classBtn="" onClick={() => handleClearFields()} >
                                        <AiOutlineClear color="#444" style={{ marginBottom: '0.3em' }} />
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div>
                    {
                        codRelatorio &&
                            codRelatorio == "SECE500" ?
                            loadingRelatorio.SECE500 === true ?
                                <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
                                :
                                urls['SECE500'] !== "" ?
                                    <ContainerRelatorio arquivoUrl={urls['SECE500']} />
                                    : <></>

                            :
                            codRelatorio == "SECE504" ?
                                loadingRelatorio.SECE504 === true ?
                                    <div className="loading-table-list-pedidos"><ReactLoading type={"bars"} color={"#0252a8"} height={30} width={50} /></div>
                                    :
                                    urls['SECE504'] !== "" ?
                                        <ContainerRelatorio arquivoUrl={urls['SECE504']} />
                                        : <></>
                                : <></>
                    }

                </div>
                <FooterRelatorios funcGerar={() => solicitarRelatorio()} funcImprimir={() => { }} regraGerar={true} regraImprimir={false} />
            </div>
            <Toaster />
        </div>
    )
}

